import React from "react";
import "./faq.css";
import SectionTitle from "../SectionTitle";
import cristelloLogo from "../../../assets/img/critstello-logo.png";
import epicoriumLogo from "../../../assets/img/epicoriums.png";
const Faq = () => {
  return (
    <>
      <section id="counts" className="counts">
        <div className="container" data-aos="fade-up">
          <SectionTitle title={"FAQ's"} />
          <div className="row " id="home_faq_">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div class="card-header" id="headingOne">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is Cutis Hospital?
                    </button>
                  </h2>
                </div>

                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Cutis Hospital is a leading dermatological healthcare
                    facility specializing in advanced clinical dermatological
                    and cosmetic treatments. Our team of{" "}
                    <a href="https://cutis.org.in/consultants">
                      experienced dermatologists
                    </a>{" "}
                    and skilled professionals is dedicated to delivering the
                    highest quality care to our patients.
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingTwo">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What services does Cutis Hospital offer?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwo"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Cutis Hospital offers a wide range of services, including
                    clinical dermatology, cosmetic dermatology, laser
                    treatments, skin surgery,{" "}
                    <a href="https://cutis.org.in/service/hair/hair-transplantation">
                      hair transplantation,
                    </a>{" "}
                    nail care, anti-ageing treatments, and more. We provide
                    comprehensive solutions for various skin conditions and
                    aesthetic concerns.
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header" id="headingThree">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      How do I schedule an appointment at Cutis Hospital?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThree"
                  class="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Scheduling an{" "}
                    <a href="https://appointment.cutis.org.in/">
                      appointment at Cutis Hospital
                    </a>{" "}
                    is easy. You can call our clinic or use our online booking
                    system on our website to choose a convenient date and time
                    for your visit. Our staff will assist you in booking your
                    appointment.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnFour">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Are the doctors at Cutis Hospital qualified and
                      experienced?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFour"
                  class="collapse"
                  aria-labelledby="headingFour"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Our team of doctors at Cutis Hospital comprises highly
                    qualified and experienced{" "}
                    <a href="https://cutis.org.in/consultants">
                      dermatologists and specialists in Bangalore
                    </a>
                    They are dedicated to staying updated with the latest
                    advancements in dermatology to provide the best possible
                    care for our patients.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnFive">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Is Cutis Hospital safe and clean for patients?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFive"
                  class="collapse"
                  aria-labelledby="headingFive"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, maintaining a safe and clean environment for our
                    patients is a top priority at Cutis Hospital. We adhere to
                    strict hygiene and sanitation standards to ensure the
                    well-being of our patients.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnSix">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      How can I learn more about the treatments and procedures
                      offered at Cutis Hospital?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseSix"
                  class="collapse"
                  aria-labelledby="headingSix"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    You can find detailed information about our treatments and
                    procedures on our website. Additionally, you can schedule a
                    consultation with one of our doctors to discuss your
                    specific concerns and explore suitable treatment options.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnSeven">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseSeven"
                      aria-expanded="false"
                      aria-controls="collapseSeven"
                    >
                      What sets Cutis Hospital apart from other dermatology
                      clinics?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseSeven"
                  class="collapse"
                  aria-labelledby="headingSeven"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Cutis Hospital stands out for its commitment to providing
                    personalized care, state-of-the-art technology, and a team
                    of highly skilled professionals. We take a patient-centric
                    approach, tailoring treatments to individual needs.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnEight">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseEight"
                      aria-expanded="false"
                      aria-controls="collapseEight"
                    >
                      What is Cutis Hospital's commitment to patient privacy?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseEight"
                  class="collapse"
                  aria-labelledby="headingEight"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Cutis Hospital takes patient privacy seriously. We adhere to
                    strict{" "}
                    <a href="https://cutis.org.in/privacy-policy">
                      confidentiality and data protection protocols
                    </a>{" "}
                    to ensure the security and confidentiality of your medical
                    information. Your information will not be shared without
                    your consent.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnNine">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseNine"
                      aria-expanded="false"
                      aria-controls="collapseNine"
                    >
                      What are the visiting hours for patients at the hospital?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseNine"
                  class="collapse"
                  aria-labelledby="headingNine"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Visiting hours at Cutis Hospital are as follows:
                    <ul>
                      <li> Monday, Tuesday, Thursday: 9 A.M – 8 P.M</li>
                      <li> Wednesday, Friday: 10 A.M – 8 P.M</li>
                      <li> Saturday: 9 A.M – 5 P.M</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnTen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTen"
                      aria-expanded="false"
                      aria-controls="collapseTen"
                    >
                      How can I pay the hospital bills?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTen"
                  class="collapse"
                  aria-labelledby="headingTen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    You can settle your hospital bills in person at our billing
                    department, by phone, or through our online payment portal.
                    We accept various payment methods for your convenience.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnEleven">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseEleven"
                      aria-expanded="false"
                      aria-controls="collapseEleven"
                    >
                      Is there a pharmacy on-site for prescription medications?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseEleven"
                  class="collapse"
                  aria-labelledby="headingEleven"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, we have an on-site pharmacy where you can fill your
                    prescriptions. It is conveniently located within the
                    hospital premises.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnTwelve">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwelve"
                      aria-expanded="false"
                      aria-controls="collapseTwelve"
                    >
                      How can I provide feedback about my experience at the
                      hospital?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwelve"
                  class="collapse"
                  aria-labelledby="headingTwelve"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    We value your feedback. You can share your thoughts and
                    experiences by{" "}
                    <a href="https://cutis.org.in/contact">
                      contacting our patient relations department
                    </a>
                    in person, by phone, or through our website.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnThirteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseThirteen"
                      aria-expanded="false"
                      aria-controls="collapseThirteen"
                    >
                      Do you have information on health and wellness resources
                      for the community?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseThirteen"
                  class="collapse"
                  aria-labelledby="headingThirteen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, we regularly host health and wellness events and
                    provide educational resources for the community on our
                    blogs. Check our website or{" "}
                    <a href="https://cutis.org.in/contact">contact</a> our
                    customer support for more details.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnFourteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFourteen"
                      aria-expanded="false"
                      aria-controls="collapseFourteen"
                    >
                      What is Cutiskart Online Pharmacy?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFourteen"
                  class="collapse"
                  aria-labelledby="headingFourteen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <a href="https://www.cutiskart.com/">
                      Cutiskart Online Pharmacy{" "}
                    </a>
                    is a convenient platform that allows you to purchase a wide
                    range of pharmaceutical products from the comfort of your
                    home. We provide a seamless online shopping experience for
                    all your dermatological healthcare needs.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnFifteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseFifteen"
                      aria-expanded="false"
                      aria-controls="collapseFifteen"
                    >
                      How do I place an order on Cutiskart?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseFifteen"
                  class="collapse"
                  aria-labelledby="headingFifteen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    To place an order, simply browse our{" "}
                    <a href="https://www.cutiskart.com/">website</a>, select the
                    desired products, and add them to your cart. Proceed to
                    checkout, fill in your details, and choose a payment method.
                    Once the order is confirmed, it will be processed and
                    delivered to your specified address.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnSixteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseSixteen"
                      aria-expanded="false"
                      aria-controls="collapseSixteen"
                    >
                      Do the Cutis Hospital have any branches?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseSixteen"
                  class="collapse"
                  aria-labelledby="headingSixteen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, Cutis has branches located in HSR Layout (Bengaluru)
                    and Kochi (Kerala) under the name of Epicorium Skin Clinics.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnSeventeen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseSeventeen"
                      aria-expanded="false"
                      aria-controls="collapseSeventeen"
                    >
                      What services does Epicorium Chain of Clinics offer?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseSeventeen"
                  class="collapse"
                  aria-labelledby="headingSeventeen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Epicorium provides a comprehensive range of services
                    specializing in skin, hair, nail, and laser treatments.{" "}
                    <a href="https://epicorium.com/">
                      Epicorium Derma clinics in bangalore
                    </a>{" "}
                    are dedicated to delivering high-quality care tailored to
                    your individual needs.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnEighteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseEighteen"
                      aria-expanded="false"
                      aria-controls="collapseEighteen"
                    >
                      Does Cutis have its own cosmetic brand?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseEighteen"
                  class="collapse"
                  aria-labelledby="headingEighteen"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, Cutis has its own cosmetics brand named{" "}
                    <a href="https://www.cristello.in/pages/our-story">
                      Cristello
                    </a>
                    , which is designed by Dermatologists.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnNineteen">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseNineteen"
                      aria-expanded="false"
                      aria-controls="collapseNineteen"
                    >
                      Can I purchase Cristello products online?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseNineteen"
                  class="collapse"
                  aria-labelledby="headingNineteen "
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Yes, Cristello products are available for purchase through
                    our{" "}
                    <a href="https://www.cristello.in/categories/shop">
                      official website.
                    </a>{" "}
                    You can explore our range, place orders, and have your
                    favorite skincare products conveniently delivered to your
                    doorstep.
                  </div>
                </div>
              </div>

              <div class="card">
                <div class="card-header" id="headingnTwenty">
                  <h2 class="mb-0">
                    <button
                      class="btn btn-link btn-block text-left collapsed"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseTwenty"
                      aria-expanded="false"
                      aria-controls="collapseTwenty"
                    >
                      What makes Cristello stand out as an in-house skincare
                      brand?
                    </button>
                  </h2>
                </div>
                <div
                  id="collapseTwenty"
                  class="collapse"
                  aria-labelledby="headingTwenty"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    Cristello distinguishes itself through carefully crafted
                    formulations, exclusively designed to meet the diverse
                    skincare needs of our patients. Our in-house experts focus
                    on quality, innovation, and addressing specific skin and
                    hair concerns.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
